import { render, staticRenderFns } from "./RuleTargetComponent.vue?vue&type=template&id=4db0f46d&"
import script from "./RuleTargetComponent.vue?vue&type=script&lang=js&"
export * from "./RuleTargetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports